import { Box } from "@prismicio/editor-ui"

import {
  headerBottomMargin,
  headerHeight,
  sidePanelWidth
} from "../../document/documentLayout"
import { sidePanelPadding } from "../documentListLayout"
import { DocumentListLocales } from "./DocumentListLocales"
import { DocumentListMenu, type SelectedMenuItem } from "./DocumentListMenu"

interface DocumentListSidePanelProps {
  selectedMenuItem?: SelectedMenuItem
}

export function DocumentListSidePanel(props: DocumentListSidePanelProps) {
  const { selectedMenuItem } = props
  return (
    <Box
      flexGrow={1}
      overflowY="auto"
      position="fixed"
      flexDirection="column"
      height={`calc(100vh - ${headerHeight}px)`}
      width={sidePanelWidth}
      padding={{ top: headerBottomMargin, ...sidePanelPadding }}
      border={{ right: true }}
      borderStyle="dashed"
      gap={24}
    >
      <DocumentListLocales />
      <DocumentListMenu selectedMenuItem={selectedMenuItem} />
    </Box>
  )
}
